'use strict';

import { addEvent } from './addEvent/addEvent';
import { initializeResponsiveMenu } from './mobileMenu/mobileMenu';

document.addEventListener('DOMContentLoaded', () => {
  initializeResponsiveMenu();
});

addEvent(window, 'load', () => {});

addEvent(window, 'resize', () => {});

addEvent(window, 'scroll', () => {});
